
export const ModalClose = "tfModalClose";

export function modalClose() {
    return {
        template
    };
}

const template = `
    <div style="position: absolute; top: 10px; right: 10px;">
        <i class="icon-cross cursor" ng-click="$dismiss()"></i>
    </div>
`;
